export default __webpack_public_path__ + "static/media/blockIconFlat.6fabcdeb.svg";